module.exports = __webpack_public_path__ + "img/check-email.0c018cad.svg";